export const environment = {
  production: true,
  apiUrl: 'https://premavalue.plataforma-smart.com',
  apiBillma: 'https://pre-billma.plataforma-smart.com',
  apiGoogle: 'AIzaSyDaCAhSi09gSzpqz2FT4U6fgLPFaLHpH4M',
  s3Url: 'https://devmavalue.plataforma-smart.com/staticontents/assets',
  adobeUrl: 'https://assets.adobedtm.com/dd4adce84cad/23557c1a8408/launch-e173f7a3916d.min.js'
};
